module.exports = __webpack_public_path__ + "static/media/title-mobile.29f74b01.png";